"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="210536" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 rounded bg-muted/10 animate-pulse" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-primary font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="footer" className="dark bg-background text-foreground py-16 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col items-start gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634544/img/skymentor_footer_logo_light.png" alt="Ferio Solutions" className="h-7" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs font-default">
              Precision-driven medical billing and RCM services designed to optimize cash flow and operational efficiency for modern healthcare providers across the US.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight text-foreground">
              Our Solutions
            </h3>
            <MenuProvider menu_id="43">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight text-foreground">
              Contact Details
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <MapPin className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>
                  7901 4th St N 27204<br />
                  St. Petersburg, FL 33702
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground font-default">
                <Phone className="size-4 shrink-0 text-primary" />
                <span>+1-813-214-0302</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground font-default">
                <Mail className="size-4 shrink-0 text-primary" />
                <span>contact@feriosolutions.com</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight text-foreground">
              Connect With Us
            </h3>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" className="text-muted-foreground hover:bg-muted/10 hover:text-primary rounded-full transition-all" asChild>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-5" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-border pt-8 font-mono text-xs text-muted-foreground md:flex-row">
          <p>
            &copy; {new Date().getFullYear()} Ferio Solutions. Engineered for accuracy.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="transition-colors hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="#" className="transition-colors hover:text-primary">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}